import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c03e4a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-score-view" }
const _hoisted_2 = {
  key: 1,
  class: "time-score-view__highscore"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Best time: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.time > 0)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(["time-score-view__time-headline", { flicker: _ctx.newBestTime }])
        }, _toDisplayString(_ctx.newBestTime ? "New best time" : "Time"), 3))
      : _createCommentVNode("", true),
    (_ctx.highscore && !_ctx.newBestTime)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.highscore), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", {
      class: _normalizeClass(["time-score-view__time", [_ctx.scoreClass, _ctx.flickerClass]])
    }, _toDisplayString(_ctx.timeOrFailMessage), 3)
  ]))
}